import { cleanName } from '../../../common/utils/text';

// Client-side validation mirroring api-reference/admin-races.md.
const MAX_NAME = 80;
const MAX_CODE = 20;

export function validateRace(form) {
    const errors = {};
    const name = cleanName(form.name);
    if (!name) errors.name = 'El nombre es obligatorio.';
    else if (name.length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;
    if (form.code && form.code.trim().length > MAX_CODE) errors.code = `Máximo ${MAX_CODE} caracteres.`;
    return errors;
}
